var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h16v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.56 13.81v5.053l2.396-2.304 2.395 2.304V13.81"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 21,
    cy: 11.234,
    r: 4
  }))));
}
export default SvgTraining;